var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcnDownarrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.43763 12.9743C7.16358 13.2849 7.1932 13.7589 7.50379 14.0329L11.5038 17.5623C11.7873 17.8125 12.2127 17.8125 12.4962 17.5623L16.4962 14.0329C16.8068 13.7589 16.8364 13.2849 16.5624 12.9743C16.2883 12.6637 15.8144 12.6341 15.5038 12.9082L12.75 15.338V7C12.75 6.58579 12.4142 6.25 12 6.25C11.5858 6.25 11.25 6.58579 11.25 7V15.338L8.49622 12.9082C8.18563 12.6341 7.71168 12.6637 7.43763 12.9743Z",
    fill: "#B6B8D5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnDownarrow);
export default __webpack_public_path__ + "static/media/icn-downarrow.b4355bb679097296b1e6480fab6470ae.svg";
export { ForwardRef as ReactComponent };